import { Tag } from '../../types/shared';

import { TagTypes } from '../../tokens';

const getUniqueTags = (tags: Tag[]): Tag[] => [
  ...new Map(tags.map((tag) => [tag.id, tag])).values(),
];

const getMainTags = (tags: Tag[]): Tag[] =>
  tags.filter(
    (tag) =>
      ![TagTypes.SEGMENT, TagTypes.TOPIC].some((type) => type === tag.type)
  );

const getSubTags = (tags: Tag[]): Tag[] =>
  tags.filter((tag) => [TagTypes.TOPIC].some((type) => type === tag.type));

const getTagsByTypes = (tags: Tag[], types: TagTypes[]): Tag[] =>
  tags.filter((tag) => types.includes(tag.type as TagTypes));

export const getTagsByPriority = (tags: Tag[], types: TagTypes[]): Tag[] => {
  const priorityMap: { [key in TagTypes]: number } = {
    [TagTypes.CATEGORY]: 1,
    [TagTypes.TOPIC]: 2,
    [TagTypes.SECTOR]: 3,
    [TagTypes.SEGMENT]: 4,
    [TagTypes.CHALLENGE]: 5,
    [TagTypes.PRODUCT]: 6,
    [TagTypes.PRODUCT_CATEGORY]: 7,
    [TagTypes.CONTENT_TYPE]: 8,
  };

  return tags
    .filter((tag) => types.includes(tag.type as TagTypes))
    .sort((a, b) => {
      const priorityA = priorityMap[a.type as TagTypes];
      const priorityB = priorityMap[b.type as TagTypes];
      return priorityA - priorityB;
    })
    .slice(0, 2);
};

const sortTagsAlphabetically = (tags: Tag[]): Tag[] =>
  tags.sort((currentTag, previousTag) =>
    currentTag.name.localeCompare(previousTag.name)
  );

export {
  getMainTags,
  getSubTags,
  getTagsByTypes,
  getUniqueTags,
  sortTagsAlphabetically,
};
